import { $http } from "@/assets/js/appFunc";

export const getEntities = (context) => {
    const req = {
        type: "GET",
        url: "/datastore/entities"
    };
    return $http(req, true).then(
        data => {
            context.commit("setEntityList", data.data);
            return data;
        }
    );
};

export const getAttributes = (context, entityCode) => {
    const req = {
        type: "GET",
        url: `/datastore/entities/${entityCode}/attributes`
    };
    return $http(req, true);
};
export const getAuditTableHeader = (context, entityCode) => {
    const req = {
        type: "GET",
        url: `/datastore/entities/${entityCode}/audit/attributes`
    };
    return $http(req, true);
};

export const getEntityPermissions = (context, entityCode) => {
    const req = {
        type: "GET",
        url: `/datastore/entities/${entityCode}/permissions`
    };
    return $http(req, true);
};

export const saveEntityPermissions = (context, payload) => {
    const req = {
        type: "PUT",
        url: `/datastore/entities/${payload.entityC}/permissions`,
        data: payload.dataToSend
    };
    return $http(req, true);
};

export const getEntityData = (context, payload) => {
    const req = {
        type: "POST",
        url: "/datastore/entities/rows/paged",
        data: payload
    };
    return $http(req, true).then(data => data,
        error => error);
};

export const getAuditData = (context, payload) => {
    const req = {
        type: "POST",
        url: "/datastore/entities/audit/rows/paged",
        data: payload
    };
    return $http(req, true).then(data => data,
        error => error);
};

export const getStructureAudit = (context, payload) => {
    const req = {
        type: "POST",
        url: "/datastore/entities/struct/audit",
        data: payload
    };
    return $http(req, true).then(({ data }) => data,
        error => error);
};

export const getEntityStructureAudit = (context, { entityCode, ...payload }) => {
    const req = {
        type: "POST",
        url: `/datastore/entities/${entityCode}/struct/audit`,
        data: payload
    };
    return $http(req, true).then(({ data }) => data,
        error => error);
};

export const deleteRows = (context, { entityCode, rowId }) => {
    const req = {
        type: "DELETE",
        url: `/datastore/entities/${entityCode}/rows/${rowId}`
    };
    return $http(req, true);
};

export const saveEntityData = (context, payload) => {
    const req = {
        type: "POST",
        url: "/datastore/entities/rows/edit",
        data: payload
    };
    return $http(req, true).then(data => data,
        error => error);
};

export const addAttributesGDM = (context, { entityCode, type, name, code }) => {
    const req = {
        type: "PATCH",
        noNotify: true,
        url: `/datastore/entities/${entityCode}/attributes`,
        data: [{ type, name, code }]
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const deleteAttribute = (context, { entityCode, attrCode }) => {
    const req = {
        type: "DELETE",
        url: `/datastore/entities/${entityCode}/attributes/${attrCode}`
    };
    return $http(req, true);
};

export const deleteAllData = (context, entityCode) => {
    const req = {
        type: "DELETE",
        url: `/datastore/entities/${entityCode}/rows`
    };
    return $http(req, true);
};

export const renameEntity = (context, payload) => {
    const req = {
        type: "PATCH",
        noNotify: true,
        url: `/datastore/entities/${payload.entityCode}`,
        data: { name: payload.name }
    };
    return $http(req, true);
};

export const editAttribute = (context, payload) => {
    const req = {
        type: "PATCH",
        noNotify: true,
        url: `/datastore/entities/${payload.entityCode}/attributes/${payload.attrCode}`,
        data: { name: payload.name }
    };
    return $http(req, true);
};

export const deleteEntity = (context, entityCode) => {
    const req = {
        type: "DELETE",
        url: `/datastore/entities/${entityCode}`,
        data: entityCode
    };
    return $http(req, true);
};

export const addNewEntityDataStore = (context, payload) => {
    const req = {
        type: "POST",
        noNotify: true,
        url: "/datastore/entities",
        data: payload
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getEntityDataStore = () => {
    const req = {
        type: "GET",
        url: "/datastore/entities"
    };
    return $http(req, true);
};

export const exportTable = (context, payload) => {
    const req = {
        type: "POST",
        url: "/datastore/csv/export",
        data: payload
    };
    return $http(req);
};

export const exportAuditData = (context, payload) => {
    const req = {
        type: "POST",
        url: "/datastore/csv/audit/export",
        data: payload
    };
    return $http(req);
};

export const addNewEntityGDM = (context, payload) => {
    const req = {
        type: "POST",
        url: "/globaldata/entity/updateorinsert",
        data: payload
    };
    return $http(req, true).then(data => data,
        error => error);
};
